import * as actionTypes from "../actions/actionTypes";

const initialState = {
  listaRepresentados: [],
  listaRepresentantes: [],
  listaRepresentadosLegales: [],
  listaTerceros: [],
  representadosPorApp: [],
  persona: {},
  updateRelaciones: false,
  carpetaRepresentadoSelected: null,
  cuilValidado: false,
  errorUpdateRdosLegales: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PERSONA: {
      return {
        ...state,
        persona: action.persona,
      };
    }
    case actionTypes.SET_RELACIONES: {
      const {
        listaRepresentados,
        listaRepresentantes,
        listaRepresentadosLegales,
      } = action;
      const representadosLegales = listaRepresentadosLegales.map(
        (item, index) => {
          return {
            id: item.idUsuarioPersonaJuridica,
            cuil: item.personaJuridica.cuit
              ? item.personaJuridica.cuit.toString()
              : "",
            nombre: item.personaJuridica.razonSocial,
            cantidadPendientes: 0,
            listaRelaciones: item.relaciones,
            esRepresentacionLegal: true,
          };
        }
      );

      return {
        ...state,
        listaRepresentados,
        listaRepresentantes,
        listaRepresentadosLegales: representadosLegales,
        updateRelaciones: false,
      };
    }
    case actionTypes.SET_LISTA_TERCEROS: {
      const representados = state.listaRepresentados.reduce((acc, current) => {
        const apps = current.listaRelaciones.filter(
          ({ delegable, estado }) => delegable && estado === 1
        );

        if (apps.length) {
          acc = acc.concat({
            id: current.id,
            cuil: current.cuil,
            nombre: current.nombre,
            apps: apps.map(({ idAplicacion: id, nombreAplicacion }) => ({
              id,
              nombreAplicacion,
              delegable: false,
            })),
          });
        }
        return acc;
      }, []);

      const representadosLegales = state.listaRepresentadosLegales.map(
        (representadoLegal) => {
          return {
            ...representadoLegal,
            personaJuridica: true,
          };
        }
      );

      const listaTerceros = [...representados, ...representadosLegales];

      return {
        ...state,
        listaTerceros: listaTerceros,
      };
    }
    case actionTypes.UPDATE_RELACIONES: {
      return {
        ...state,
        updateRelaciones: true,
      };
    }
    case actionTypes.SET_REPRESENTADOS_POR_APP: {
      return {
        ...state,
        representadosPorApp: action.representadosPorApp,
      };
    }
    case actionTypes.SET_CARPETA_REPRESENTADO_SELECCIONADO: {
      return {
        ...state,
        carpetaRepresentadoSelected: action.carpetaRepresentadoSelected,
      };
    }
    case actionTypes.SET_VALIDACION_CUIL: {
      return {
        ...state,
        cuilValidado: action.validado,
      };
    }
    case actionTypes.SET_ERROR_UPDATE_RDOS_LEGALES:
      return {
        ...state,
        errorUpdateRdosLegales: true,
      };
    default:
      return state;
  }
};

export default reducer;
